export default function workflowFilters() {
  return {
    statusOpen: false,
    typeOpen: false,
    selectedStatuses: [],
    selectedTypes: [],
    startedAfter: "",
    startedBefore: "",

    init() {
      const el = this.$el;
      this.selectedStatuses = JSON.parse(el.dataset.statuses || "[]");
      this.selectedTypes = JSON.parse(el.dataset.types || "[]");
      this.startedAfter = el.dataset.startedAfter || "";
      this.startedBefore = el.dataset.startedBefore || "";
    },

    toggleStatus(val) {
      const i = this.selectedStatuses.indexOf(val);
      if (i === -1) this.selectedStatuses.push(val);
      else this.selectedStatuses.splice(i, 1);
      this.submitForm();
    },

    toggleType(val) {
      const i = this.selectedTypes.indexOf(val);
      if (i === -1) this.selectedTypes.push(val);
      else this.selectedTypes.splice(i, 1);
      this.submitForm();
    },

    hasFilters() {
      return (
        this.selectedStatuses.length ||
        this.selectedTypes.length ||
        this.startedAfter ||
        this.startedBefore
      );
    },

    clearStatuses() {
      this.selectedStatuses = [];
      this.statusOpen = false;
      this.submitForm();
    },

    clearTypes() {
      this.selectedTypes = [];
      this.typeOpen = false;
      this.submitForm();
    },

    submitForm() {
      // Double $nextTick: first tick lets Alpine update x-for templates
      // (add/remove hidden inputs), second tick submits the form with correct DOM
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$refs.filterForm.submit();
        });
      });
    },
  };
}
